/* Find A Funeral Home — storefront half of the finder.
 *
 * Talks to the search service on find.discount-caskets.com. Nothing about the
 * directory lives in the theme; this file only turns the API's JSON into the
 * site's own cards, and keeps the query in the URL so a result set can be
 * shared, bookmarked and reached again with the back button.
 */
(function () {
  'use strict';

  var MILES = ' mi';

  function init(root) {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = '1';

    var api = (root.dataset.api || '').replace(/\/+$/, '');
    var pageSize = parseInt(root.dataset.pageSize, 10) || 24;

    var form = root.querySelector('[data-finder-form]');
    var input = root.querySelector('[data-finder-input]');
    var submit = root.querySelector('[data-finder-submit]');
    var locate = root.querySelector('[data-finder-locate]');
    var radius = root.querySelector('[data-finder-radius]');
    var status = root.querySelector('[data-finder-status]');
    var choicesBox = root.querySelector('[data-finder-choices]');
    var results = root.querySelector('[data-finder-results]');
    var more = root.querySelector('[data-finder-more]');
    var sentinel = root.querySelector('[data-finder-sentinel]');

    // The search currently on screen. `origin` is either a typed query or a
    // pair of coordinates from the device.
    var state = { q: null, lat: null, lon: null, page: 1, total: 0, loaded: 0, busy: false };

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function say(msg, isError) {
      status.textContent = msg || '';
      status.classList.toggle('funeral-finder__status--error', !!isError);
    }

    function busy(on) {
      state.busy = on;
      if (submit) submit.setAttribute('aria-busy', on ? 'true' : 'false');
      if (more) more.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function clear() {
      results.innerHTML = '';
      choicesBox.innerHTML = '';
      choicesBox.hidden = true;
      more.hidden = true;
      state.loaded = 0;
      state.total = 0;
    }

    function tel(phone) {
      return String(phone || '').replace(/[^\d+]/g, '');
    }

    function card(r) {
      var li = document.createElement('li');
      li.className = 'funeral-home-card';

      var addr = [r.street, [r.city, r.state].filter(Boolean).join(', '), r.postcode]
        .filter(Boolean).join('<br>');

      // A thumbnail sourced from a favicon or a wordmark is usually a logo, and
      // cropping one to fill a 4:3 box cuts its ends off. The API does not say
      // which is which, so letterbox anything that is not a page photograph.
      var media;
      if (r.thumb) {
        media = '<img class="funeral-home-card__image" src="' + esc(api + r.thumb) +
                '" alt="" width="480" height="360" loading="lazy" decoding="async">';
      } else {
        media = '<div class="funeral-home-card__placeholder" aria-hidden="true">' +
                esc((r.name || '?').trim().charAt(0).toUpperCase()) + '</div>';
      }

      var links = [];
      if (r.phone) {
        links.push('<a class="funeral-home-card__link" href="tel:' + esc(tel(r.phone)) +
                   '">' + esc(r.phone) + '</a>');
      }
      if (r.website) {
        // rel=nofollow: these are not endorsements, and the directory is large
        // enough that passing link equity to 14,000 sites would be its own thing.
        links.push('<a class="funeral-home-card__link" href="' + esc(r.website) +
                   '" target="_blank" rel="noopener nofollow">Visit website</a>');
      }

      li.innerHTML =
        '<div class="funeral-home-card__media">' + media +
          (typeof r.distance === 'number'
            ? '<span class="funeral-home-card__distance">' + esc(r.distance.toFixed(1)) + MILES + '</span>'
            : '') +
        '</div>' +
        '<div class="funeral-home-card__body">' +
          '<h3 class="funeral-home-card__name">' + esc(r.name) + '</h3>' +
          '<p class="funeral-home-card__address">' + addr + '</p>' +
          (links.length ? '<div class="funeral-home-card__links">' + links.join('') + '</div>' : '') +
        '</div>';
      return li;
    }

    function showChoices(choices) {
      choicesBox.innerHTML = '';
      choices.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'funeral-finder__choice';
        b.textContent = c.label;
        b.addEventListener('click', function () {
          input.value = c.label;
          run({ q: c.label, reset: true });
        });
        choicesBox.appendChild(b);
      });
      choicesBox.hidden = choices.length === 0;
    }

    function url(page) {
      var p = new URLSearchParams();
      if (state.lat != null) {
        p.set('lat', state.lat);
        p.set('lon', state.lon);
      } else {
        p.set('q', state.q || '');
      }
      p.set('radius', radius ? radius.value : '50');
      p.set('limit', pageSize);
      p.set('page', page);
      return api + '/api/search?' + p.toString();
    }

    function pushUrl() {
      if (!window.history || !window.history.replaceState) return;
      var p = new URLSearchParams(window.location.search);
      if (state.lat != null) {
        p.delete('q');
        p.set('near', state.lat.toFixed(5) + ',' + state.lon.toFixed(5));
      } else {
        p.delete('near');
        if (state.q) p.set('q', state.q); else p.delete('q');
      }
      if (radius) p.set('radius', radius.value);
      window.history.replaceState({}, '', window.location.pathname + '?' + p.toString());
    }

    function summarise(d) {
      var where = d.origin && d.origin.label ? d.origin.label : 'that area';
      if (!d.total) {
        return 'No funeral homes found near ' + where + '. Try a wider radius.';
      }
      var n = d.total === 1 ? '1 funeral home' : d.total.toLocaleString() + ' funeral homes';
      var s = n + ' near ' + where;
      // The API widens the radius by itself rather than reporting nothing when
      // the nearest firm is 60 miles away — say so, or the number looks wrong
      // against the radius the visitor picked.
      if (d.widened) s += ', within ' + d.widened + ' miles';
      return s + '.';
    }

    function run(opts) {
      opts = opts || {};
      if (state.busy) return;

      if (opts.reset) {
        if (opts.q != null) { state.q = opts.q; state.lat = null; state.lon = null; }
        if (opts.lat != null) { state.lat = opts.lat; state.lon = opts.lon; state.q = null; }
        state.page = 1;
        clear();
      } else {
        state.page += 1;
      }

      if (state.q == null && state.lat == null) return;
      if (state.q != null && !String(state.q).trim()) {
        say('Enter an address, city or ZIP code.', true);
        return;
      }

      busy(true);
      if (opts.reset) say('Searching…');

      fetch(url(state.page), { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          if (d.error) throw new Error(d.error);

          if (!d.origin) {
            clear();
            say(d.message || 'We could not find that place.', !d.choices || !d.choices.length);
            if (d.choices && d.choices.length) showChoices(d.choices);
            return;
          }

          choicesBox.hidden = true;
          state.total = d.total || 0;

          var frag = document.createDocumentFragment();
          (d.results || []).forEach(function (r) { frag.appendChild(card(r)); });
          results.appendChild(frag);
          state.loaded += (d.results || []).length;

          say(summarise(d));
          more.hidden = state.loaded >= state.total;
          pushUrl();
        })
        .catch(function (err) {
          // Do not leave a half-loaded list looking complete.
          if (opts.reset) clear();
          say('The funeral home directory is not responding right now. Please try again shortly.', true);
          if (window.console) console.warn('[funeral-finder]', err);
        })
        .then(function () { busy(false); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      run({ q: input.value, reset: true });
    });

    if (radius) {
      radius.addEventListener('change', function () {
        if (state.q != null || state.lat != null) {
          run(state.lat != null ? { lat: state.lat, lon: state.lon, reset: true }
                                : { q: state.q, reset: true });
        }
      });
    }

    if (locate) {
      locate.addEventListener('click', function () {
        if (!navigator.geolocation) {
          say('This browser cannot share your location. Enter a ZIP code instead.', true);
          return;
        }
        locate.setAttribute('aria-busy', 'true');
        say('Finding your location…');
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            locate.setAttribute('aria-busy', 'false');
            input.value = '';
            run({ lat: pos.coords.latitude, lon: pos.coords.longitude, reset: true });
          },
          function (err) {
            locate.setAttribute('aria-busy', 'false');
            say(err && err.code === 1
              ? 'Location access was declined. Enter an address, city or ZIP code instead.'
              : 'We could not get your location. Enter an address, city or ZIP code instead.', true);
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      });
    }

    if (more) more.addEventListener('click', function () { run(); });

    // Infinite scroll, with the button as the accessible fallback: the button
    // stays in the DOM and keyboard-reachable whether or not this fires.
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !more.hidden && !state.busy) run();
      }, { rootMargin: '400px 0px' }).observe(sentinel);
    }

    // Re-run whatever the URL asks for, so a shared link lands on results.
    var params = new URLSearchParams(window.location.search);
    if (radius && params.get('radius')) radius.value = params.get('radius');
    var near = params.get('near');
    if (near && /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(near)) {
      var xy = near.split(',');
      run({ lat: parseFloat(xy[0]), lon: parseFloat(xy[1]), reset: true });
    } else if (params.get('q')) {
      input.value = params.get('q');
      run({ q: input.value, reset: true });
    }
  }

  function boot() {
    document.querySelectorAll('.funeral-finder[data-api]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', boot);
})();
